import { Space, Table, Typography } from 'antd';
import { TableProps } from 'antd/lib/table';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import IconButton from 'components/new-ui/base/icon-button/IconButton';
import { StyledTableHeaderCell } from 'components/new-ui/base/table/styles';
import { Box44StyledTableWrapper } from './styles';

export type Box44TableRecord = {
    id: string;
    code: string;
    reference: string;
};

type Props<Record> = Omit<TableProps<Record>, 'dataSource'> & {
    dataSource: Record[];
    onDelete: (code: string) => void;
    onEdit: (code: string) => void;
    onPreview: (code: string) => void;
    viewOnly?: boolean | undefined;
};

const Box44Table = ({ dataSource, onEdit, viewOnly, onDelete, onPreview, ...rest }: Props<Box44TableRecord>) => {
    return (
        <Box44StyledTableWrapper>
            <Table<Box44TableRecord>
                rowKey="id"
                dataSource={dataSource}
                columns={[
                    {
                        width: 180,
                        key: 'code',
                        title: 'Box 44 Code',
                        render: (_, record) => {
                            return <Typography.Text>{record.code}</Typography.Text>;
                        },
                    },
                    {
                        key: 'reference',
                        title: 'Reference',
                        render: (_, record) => {
                            return <Typography.Text>{record.reference}</Typography.Text>;
                        },
                    },
                    {
                        width: 85,
                        align: 'right',
                        key: 'actions',
                        title: 'Actions',
                        render: (_, record) => {
                            return (
                                <Space size={8}>
                                    {viewOnly ? (
                                        <IconButton
                                            tooltipText={'Preview'}
                                            icon={<EyeOutlined />}
                                            onClick={() => onPreview?.(record.code)}
                                        />
                                    ) : (
                                        <>
                                            <IconButton
                                                tooltipText={'Edit'}
                                                icon={<EditOutlined />}
                                                onClick={() => onEdit?.(record.code)}
                                            />
                                            <IconButton
                                                tooltipText={'Delete'}
                                                icon={<DeleteOutlined />}
                                                onClick={() => onDelete?.(record.code)}
                                            />
                                        </>
                                    )}
                                </Space>
                            );
                        },
                    },
                ]}
                components={{
                    header: {
                        cell: (props: any) => <StyledTableHeaderCell {...props} />,
                    },
                }}
                pagination={{
                    pageSize: 10,
                    hideOnSinglePage: true,
                    position: ['bottomCenter'],
                    total: dataSource.length,
                }}
                {...rest}
            />
        </Box44StyledTableWrapper>
    );
};

export default Box44Table;
